export default __webpack_public_path__ + "static/media/Manufacturing NK cell products for clinical research.9183e749.pdf";